import React from "react";
import { Provider } from "react-redux";
import { store } from "../redux/store";

export function WithRedux<TProps extends {} = {}>(
  Child: React.ComponentType<TProps>
) {
  return (props: TProps) => (
    <Provider store={store}>
      <Child {...props} />
    </Provider>
  );
}
